import { VideoPlayerTypes } from '@as-react/common-types';
const YOUTUBE_IFRAME_API = 'https://www.youtube.com/iframe_api';
const VIMEO_PLAYER_SRC = 'https://player.vimeo.com/api/player.js';
const vimeoLoadQueue = [];
let vimeoIsReady = false;
let youtubeLoadQueue = [];
export const addVimeoReadyEvent = (callback) => {
    if (vimeoIsReady) {
        callback();
    }
    else {
        vimeoLoadQueue.push(callback);
    }
};
const onVimeoAPIReady = () => {
    vimeoIsReady = true;
    vimeoLoadQueue.forEach(callback => {
        callback();
    });
};
export const addYoutubeReadyEvent = (callback) => {
    if (window.youtubeIsReady) {
        callback();
    }
    else {
        youtubeLoadQueue.push(callback);
    }
};
const handleYouTubeIframeAPIReady = () => {
    window.youtubeIsReady = true;
    youtubeLoadQueue.forEach(callback => callback());
    youtubeLoadQueue = [];
};
export const setupYouTubeIframeAPIReadyHandler = () => {
    if (window.youtubeIsReady) {
        handleYouTubeIframeAPIReady();
    }
    else if (window.onYouTubeIframeAPIReady) {
        const originalHandler = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = () => {
            handleYouTubeIframeAPIReady();
            originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler();
        };
    }
    else {
        window.onYouTubeIframeAPIReady = handleYouTubeIframeAPIReady;
    }
};
export const injectYoutubeAPI = () => {
    if (document.querySelectorAll(`script[src="${YOUTUBE_IFRAME_API}"]`).length === 0) {
        const tag = document.createElement('script');
        tag.src = YOUTUBE_IFRAME_API;
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
};
export const injectVimeoAPI = () => {
    if (document.querySelectorAll(`script[src="${VIMEO_PLAYER_SRC}"]`).length === 0) {
        const tag = document.createElement('script');
        tag.src = VIMEO_PLAYER_SRC;
        tag.onload = onVimeoAPIReady;
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
};
export const getVimeoId = (vimeoUrl) => {
    const match = /vimeo.*\/(\d+)/i.exec(vimeoUrl);
    return match ? Number(match[1]) : undefined;
};
export const getYouTubeId = (url) => {
    const match = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/.exec(url);
    return match ? match[2] : undefined;
};
export const getYouTubeVideoUrl = (videoId) => `https://www.youtube-nocookie.com/embed/${videoId}?wmode=opaque&rel=0&enablejsapi=1`;
export const getVideoPlayerType = (url) => {
    if (!url) {
        return null;
    }
    else if (url.includes('youtube')) {
        return VideoPlayerTypes.YOUTUBE;
    }
    else if (url.includes('vimeo')) {
        return VideoPlayerTypes.VIMEO;
    }
    else {
        return VideoPlayerTypes.NATIVE;
    }
};
